const theme = {
  // palette: {
  //   primary: { main: '#00FF00', contrastText: '#000000' },
  // },

}

export default theme